/**
 * What the journal card's body shows (components/appointment-card.tsx).
 *
 * The body used to render only when the booking had services, so a booking
 * without them lost its comment too. YClients salons hold a master's time that
 * way: no client, no services, the reason in the comment («обучение», «Адм Оля»);
 * the import brings it in as it is (Laser Love 1321705, 2026-10-19). The comment
 * shows whenever there is one, and the hidden-phone dots only when there is a
 * client whose phone is hidden.
 */
export type CardBodyInput = {
  title?: string | null;
  details?: string | null;
  clientName?: unknown;
  phone?: string | null;
};

export type CardBody = {
  show: boolean;
  title: boolean;
  details: boolean;
  /** "••••••" in place of the phone, for staff who may not see phones */
  maskedPhone: boolean;
};

export function cardBody({ title, details, clientName, phone }: CardBodyInput, canShowPhone: boolean): CardBody {
  const hasTitle = Boolean(title);
  const hasDetails = Boolean(details);
  const hasClient = Boolean(clientName) || Boolean(phone);
  return {
    show: hasTitle || hasDetails,
    title: hasTitle,
    details: hasDetails,
    maskedPhone: !canShowPhone && hasClient,
  };
}
